import { SendableTransaction, TransactionStatus, AnalyticsInfo } from "@bridgesplit/utils";
import { Commitment } from "@solana/web3.js";

export type TransactionWithIdentifier = {
    identifier: string;
    transaction: SendableTransaction;
    analyticsInfo?: AnalyticsInfo;
};
export type SendableTransactionWithIdentifier = {
    identifier: string;
    transaction: string;
    transactionType: TransactionType;
};

export interface TransactionWithIdentifiersAndSetup {
    setupTransactions: TransactionWithIdentifier[];
    transactions: TransactionWithIdentifier[];
}

// Transactions to send in parallel
export interface ParallelTransactionsBatch {
    transactions: TransactionWithIdentifier[];
    commitmentLevel?: Commitment;
    allowFailure?: boolean;
    bundle?: BundleOptions;
}

export interface SendableParallelTransactionsBatch {
    transactions: SendableTransactionWithIdentifier[];
    commitmentLevel?: Commitment;
    bundle?: BundleOptions;
}

export interface SendTransactionsInterface {
    batches: SendableParallelTransactionsBatch[];
    mpcIdentifier?: string;
}

export enum BundleOptions {
    Priority = 0,
    BundleOnly = 1
}

export interface TransactionResult {
    signature: string;
    status: TransactionStatus;
    identifier: string;
    error?: string;
    simulationLogs?: string[];
    bundleId?: string;
}

export type OrderedTransactions = ParallelTransactionsBatch[];

export interface AccountWithOwner {
    account: string;
    owner: string;
    mint: string;
}

export enum TransactionType {
    Legacy = 0,
    V0 = 1
}
